var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhonelink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2724_2273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.87714 6H22.8771V4H4.87714C3.77714 4 2.87714 4.9 2.87714 6V17H0.877136V20H14.8771V17H4.87714V6ZM23.8771 8H17.8771C17.3271 8 16.8771 8.45 16.8771 9V19C16.8771 19.55 17.3271 20 17.8771 20H23.8771C24.4271 20 24.8771 19.55 24.8771 19V9C24.8771 8.45 24.4271 8 23.8771 8ZM22.8771 17H18.8771V10H22.8771V17Z",
    fill: "#030712"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2724_2273"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.877136)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonelink);
export default __webpack_public_path__ + "static/media/phonelink.99175b9e85275076eb1e6f922f4f66da.svg";
export { ForwardRef as ReactComponent };